<!--基于v-charts和echarts的环图-->
<template>
  <div class="chart">
    <ve-ring
      height="100%"
      :data="chartData"
      :settings="chartSettings"
      :extend="chartExtends"
      :loading="loading"
      :data-empty="data.length? false: true"
    />
  </div>
</template>
<script>
export default {
  props: {
    columns: Array,
    data: Array,
    setting: Object,
    extend: Object,
    loading: Boolean,
    unit: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      chartData: {
        columns: this.columns,
        rows: this.data
      }
    }
  },
  computed: {
    chartSettings () {
      const setting = this.setting || {}
      const o = {
        radius: [50, 65],
        offsetY: '50%',
        label: {
          normal: {
            show: false,
            position: 'center',
            formatter: '{value|{c}}' + this.unit + '\n{label|{b}}',
            rich: {
              value: {
                padding: 5,
                align: 'center',
                verticalAlign: 'middle',
                fontSize: 16,
                color: '#000'
              },
              label: {
                align: 'center',
                verticalAlign: 'middle',
                fontSize: 16,
                color: '#000'
              }
            }
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: 16,
              color: '#000'
            }
          }
        },
        labelLine: {
          show: false
        },

        hoverAnimation: false
      }
      Object.assign(o, setting)
      return o
    },
    chartExtends () {
      /**
       * 此处配置参考echart的配置项
      */
      const extend = this.extend || {}
      const o = {
        legend: {
          show: false
        },
        tooltip: {
          show: false
        },
        color: ['#279ae6', '#bad1fa', '#fec548']
      }
      Object.assign(o, extend)
      return o
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
.chart
  height 100%
  width 100%
</style>
